import React from 'react';

const UserMessagesContext = React.createContext({});

export default UserMessagesContext;
